import { render, staticRenderFns } from "./MTLProducts.vue?vue&type=template&id=2e77e555&"
import script from "./MTLProducts.vue?vue&type=script&lang=js&"
export * from "./MTLProducts.vue?vue&type=script&lang=js&"
import style0 from "./MTLProducts.vue?vue&type=style&index=0&id=2e77e555&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports